import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { StateService } from '../services/state.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private countRequest = 0;
  public loading = false;

  constructor(
    private stateService: StateService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.includes('/createTestBackup')){
      this.countRequest++;
      this.stateService.setIsLoading(true);
      return next.handle(request)
        .pipe(
          finalize(() => {
            this.countRequest--;
            if (this.countRequest === 0) {
              this.stateService.setIsLoading(false);
            }
          })
        );
    }else{
      // For createTestBackup, we don't want to show loading
      return next.handle(request);
    }
  }
}